import { InputTitle } from 'components/input/InputTitle';
import CommonSelect from 'components/select/CustomSelect';
import { Button, Row, Spacing, TextInput, Typography, neutral } from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';

import { Container } from '../styles/form';

import { AvatarTrainer } from '../component/Avatar';
import { TrainerProfileForm } from '../component/TrainerProfileForm';
import { useFullTimeFormController } from '../core/controller/full-time-form';

export const FullTimeAddPage = () => {
  const {
    roleKey,
    institutionId,
    email,
    level,
    name,
    phone,
    levels,
    institutions,
    disabled,
    emailStatus,
    gender,
    handleSubmit,
    onChangeLevel,
    handleChange,
    onChangeGender,
    handleChangePhone,
    onChangeInstitution,
    goBack,
    logoRef,
    onChangeAvatar,
    logoURL,
    onDeleteLogo,
    firstName,
    lastName,
    onChangeSearchInstitution,
    searchSelect,
  } = useFullTimeFormController();

  const isBiologicAdmin = roleKey === RoleKey.BIOLOGIC_ADMIN;

  return (
    <Container direction="column" style={{ maxWidth: 800 }}>
      <Spacing spacing="3xl" type="margin" placement="bottom">
        <HeaderDetailPage title="Add trainer" goBack={goBack} style={{ marginBottom: 0 }} />
      </Spacing>
      <Row direction="row">
        <AvatarTrainer
          logoURL={logoURL.value}
          onChangeAvatar={onChangeAvatar}
          onDeleteLogo={onDeleteLogo}
          logoRef={logoRef}
        />
        <Row direction="column">
          {isBiologicAdmin && (
            <Row
              direction="column"
              style={{
                paddingBottom: 48,
                borderBottom: `1px solid ${neutral['neutral-5']}`,
              }}
            >
              <Spacing spacing="md" type="margin" placement="bottom">
                <Typography variant="h4" weight={600}>
                  General
                </Typography>
              </Spacing>
              {/* <InputTitle title="Email" required />
            <TextInput
              name="email"
              containerStyle={{ maxWidth: 'auto' }}
              value={email}
              onChange={handleChange}
              helperText={emailStatus.helperText}
              color={emailStatus.color}
            /> */}
              <Spacing
                spacing="xl"
                placement="top"
                type="margin"
                style={{
                  width: '100%',
                }}
              >
                <InputTitle title="Institution" required />
                {/* <SelectStyle>
                  <Select
                    inputStyle={{
                      width: '100%',
                    }}
                    containerStyle={{ maxWidth: 'none' }}
                    options={institutions}
                    selectedKeys={institutionId || ''}
                    onChange={onChangeInstitution}
                    dropdownConfig={{
                      dropdownConfig: {
                        placement: 'bottom-start',
                        offset: [-10, 4],
                      },
                    }}
                  />
                </SelectStyle> */}
                <CommonSelect
                  value={institutions.find((item: any) => item.value === institutionId)}
                  options={institutions.filter((item: any) =>
                    item.label.toLowerCase().includes(searchSelect.value.toLowerCase()),
                  )}
                  onChange={onChangeInstitution}
                  onInputChange={onChangeSearchInstitution}
                  noOptionsMessage={() => 'Not Found Institution'}
                />
              </Spacing>
            </Row>
          )}
          <TrainerProfileForm
            gender={gender}
            name={name}
            phone={phone}
            level={level}
            levels={levels}
            onChangeLevel={onChangeLevel}
            handleChangePhone={handleChangePhone}
            handleChange={handleChange}
            onChangeGender={onChangeGender}
            firstName={firstName}
            lastName={lastName}
            emailStatus={emailStatus}
          />
          {/* <TrainerPasswordForm password={password || ''} handleChange={handleChange} /> */}
          <Spacing
            spacing="4xl"
            placement="top"
            type="margin"
            style={{
              width: '100%',
            }}
          >
            <Button color="primary" disabled={disabled} onClick={() => handleSubmit()}>
              Save
            </Button>
          </Spacing>
        </Row>
      </Row>
    </Container>
  );
};
